import Datatable from '@laraveldaily/vue2-datatable'
import EventHub from "./core/plugins/EventHubPlugin/EventHub";
import acl from './core/plugins/acl'
import BackButton from './view/pages/plugins/BackButton'
import VueTypedJs from 'vue-typed-js'
import ResponseMessageFunctions from "./Utilities/ResponseMessageFunctions";
import siteSelect from "@/view/pages/components/templateComponents/siteSelect";
import ckArea from "@/view/pages/components/templateComponents/ckArea";
import keyValue from "@/view/pages/components/templateComponents/keyValue";
import priceInput from "@/view/pages/pickers/priceInput";
import siteValueSelect from "@/view/pages/components/templateComponents/siteValueSelect";
import siteLanguage from "@/view/pages/components/templateComponents/siteLanguage";
import programmingLanguageSelect from "@/view/pages/components/templateComponents/programmingLanguageSelect";
import propertiesSelector from "@/view/pages/components/templateComponents/propertiesSelector";

const GlobalComponents = {
    install(Vue) {
        Vue.use(Datatable)
        Vue.component('site-select', siteSelect)
        Vue.component('ckArea', ckArea)
        Vue.component('prop-selector', propertiesSelector)
        Vue.component('key-value', keyValue)
        Vue.component('price-input', priceInput)
        Vue.component('site-value', siteValueSelect)
        Vue.component('site-language', siteLanguage)
        Vue.component('programming-select', programmingLanguageSelect)
        Vue.use(VueTypedJs)
        Vue.use(EventHub)
        Vue.component('back-button', BackButton)
        Vue.use(acl)
        Vue.use(ResponseMessageFunctions)
    }
}

export default GlobalComponents
